import { Box, Typography } from "@mui/material";

function VideoDetails({ video }) {
  return (
    <Box
      sx={{
        display: "flex",
        flexDirection: "column",
        justifyContent: "start",
        padding: "2em",
        gap: "1em",
      }}
    >
      <Typography
        variant="h5"
        sx={{
          color: "#323232",
        }}
      >
        {video?.name}
      </Typography>
      <Typography
        variant="body1"
        sx={{
          color: "#7A7A7A",
        }}
      >
        {video?.description}
      </Typography>
    </Box>
  );
}

export default VideoDetails;
